// extracted by mini-css-extract-plugin
export default {"loaderSection":"loaderBrown_loaderSection__Ss+2a","loaderSecitionh1":"loaderBrown_loaderSecitionh1__n5K9l","lds_ring":"loaderBrown_lds_ring__u12nx"};